import "./index.scss"


/** WEBPACK FOOTER **
 ** ./src/Course/index.js
 **/